import { Component } from 'react';
import PropTypes from 'prop-types';
import { addErrorToReport } from '@americanexpress/one-app-ducks';

export default class ErrorReporter extends Component {
  constructor() {
    super();
    this.handleOnError = this.handleOnError.bind(this);
    this.handleUnhandledRejection = this.handleUnhandledRejection.bind(this);
  }

  componentDidMount() {
    window.addEventListener('error', this.handleOnError);
    window.addEventListener('unhandledrejection', this.handleUnhandledRejection);
  }

  componentDidCatch(error) {
    const { dispatch } = this.props;
    dispatch(addErrorToReport(error));
  }

  componentWillUnmount() {
    window.addEventListener('error', null);
    window.removeEventListener('unhandledrejection', this.handleUnhandledRejection);
  }

  // eslint-disable-next-line max-params -- this was build before eslint made a requirement
  handleOnError(message, file, line, col, error) {
    const { dispatch } = this.props;
    dispatch(addErrorToReport(
      error,
      {
        message,
        file,
        line,
        col,
        collectionMethod: 'onerror',
      }
    ));
  }

  handleUnhandledRejection(error) {
    const { dispatch } = this.props;
    dispatch(addErrorToReport(error, { collectionMethod: 'unhandledrejection' }));
  }

  render() {
    const { children } = this.props;
    return children;
  }
}

ErrorReporter.propTypes = {
  children: PropTypes.node,
  dispatch: PropTypes.func.isRequired,
};

ErrorReporter.defaultProps = {
  children: null,
};
